import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Badge } from "./ui/badge";
import { Heart, TrendingDown } from "lucide-react";

export default function Watchlist() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/my/watchlist").then(({ data }) => setItems(data.filter((w) => w.listing))).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <div data-testid="watchlist-section">
      <h2 className="font-display text-xl font-bold mb-3 flex items-center gap-2"><Heart className="w-5 h-5 text-pink-400" /> Watchlist</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(({ listing: l, price_when_hearted }) => {
          const drop = price_when_hearted && l.asking_price < price_when_hearted ? price_when_hearted - l.asking_price : 0;
          return (
            <Link key={l.listing_id} to={`/buy/${l.listing_id}`} data-testid={`watch-${l.listing_id}`} className="flex items-center gap-3 p-3 rounded-xl bg-[#131722] border border-slate-800 hover:border-pink-500/40">
              <div className="w-16 h-12 rounded-lg overflow-hidden bg-slate-900 shrink-0">{l.photos?.[0] && <img src={l.photos[0]} alt="" className="w-full h-full object-cover" />}</div>
              <div className="min-w-0 flex-1">
                <p className="font-semibold truncate">{l.year} {l.make} {l.model}</p>
                <p className="text-xs text-slate-400 flex items-center gap-2">${Number(l.asking_price).toLocaleString()}{drop > 0 && <span className="text-emerald-300 flex items-center gap-0.5" data-testid={`watch-drop-${l.listing_id}`}><TrendingDown className="w-3 h-3" />−${Number(drop).toLocaleString()} since you hearted</span>}</p>
              </div>
              <Badge className="bg-slate-800 text-slate-200 text-[10px] uppercase">{l.status}</Badge>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
